import React, { useState } from 'react';
import css from './FieldPassword.module.css';
import classNames from 'classnames';
import { object, string, arrayOf, oneOfType, node } from 'prop-types';
import { Field } from 'react-final-form';
import ValidationError from '../ValidationError/ValidationError';
import { injectIntl } from 'react-intl';
import { BsEyeSlash, BsEye } from 'react-icons/bs';
import { checkPasswordStrength } from '../../util/helperFunction';
import { useEffect } from 'react';
import { bool } from 'prop-types';

function FieldPasswordMainComponent(props) {
  const {
    rootClassName,
    className,
    validationErrorClassName,
    id,
    label,
    inputClassName,
    input,
    meta,
    intl,
    passwordCheckRefValues,
    onChange: propsOnChnage,
    errorClassName,
    showPassword,
    setShowPassword,
    refValue,
    customErrorText,
    pwdStrgnthCheckReq,
    ...rest
  } = props;

  const { name, onChange, value, onBlur, onFocus } = input;
  const { invalid, error, touched, valid } = meta;

  // Error message and input error styles are only shown if the
  // field has been touched and the validation has failed.

  // const hasError = !!customErrorText || !!(touched && invalid && error);

  const modifiedTouched = !!value && !!refValue && refValue !== value && !touched ? true : touched;

  const errorText = customErrorText || error;

  const hasError = !!customErrorText || !!(modifiedTouched && invalid && error);

  const fieldMeta = { touched: hasError, error: errorText };

  if (!!label && !id) {
    throw new Error('id required when a label is given');
  }

  const classes = classNames(css.root || rootClassName, className, {
    [errorClassName]: !!errorClassName && hasError,
  });
  const inputClasses = classNames(css.inputDiv, inputClassName, {
    [css.invalidInput]: hasError,
    [css.validInput]: valid,
    [css.hidePwdInputDiv]: !showPassword && !!value,
  });

  const errorClasses = classNames(css.validationError, validationErrorClassName);

  const togglePassword = event => {
    event.preventDefault();
    event.stopPropagation();
    setShowPassword(showPassword => !showPassword);
  };

  const handlePropsOnChange = value => {
    if (typeof propsOnChnage === 'function') {
      propsOnChnage(value);
    } else {
      onChange(value);
    }
  };

  const handleOnChange = event => {
    event.preventDefault();
    event.stopPropagation();
    const newValue = event.target.value;
    handlePropsOnChange(newValue);
  };

  const handleOnBlur = event => {
    event.preventDefault();
    event.stopPropagation();
    const newValue = event.target.value;
    onBlur(newValue);
  };

  const handleOnFocus = event => {
    event.preventDefault();
    event.stopPropagation();
    const newValue = event.target.value;
    onFocus(newValue);
  };

  const { alertType, message: alertMessag } =
    !!value && !hasError && pwdStrgnthCheckReq
      ? checkPasswordStrength(intl, value, passwordCheckRefValues)
      : {};

  return (
    <React.Fragment>
      <div className={classes}>
        {!!label && !!id ? <label htmlFor={id}>{label}</label> : null}
        <div className={inputClasses}>
          <input
            type={showPassword ? 'text' : 'password'}
            {...rest}
            name={name}
            id={id}
            value={value}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            onFocus={handleOnFocus}
          />
          <button type="button" onClick={togglePassword}>
            {showPassword ? <BsEye /> : <BsEyeSlash />}
          </button>
        </div>
        <ValidationError className={errorClasses} fieldMeta={fieldMeta} />
        {!hasError && !!value && (
          <div className={classNames(css.strngthMsg, css[alertType])}>{alertMessag}</div>
        )}
      </div>
    </React.Fragment>
  );
}

FieldPasswordMainComponent.defaultProps = {
  rootClassName: null,
  className: null,
  validationErrorClassName: null,
  inputClassName: null,
  id: null,
  label: null,
  passwordCheckRefValues: [],
  errorClassName: null,
  customErrorText: null,
  pwdStrgnthCheckReq: true,
};

FieldPasswordMainComponent.propTypes = {
  rootClassName: string,
  className: string,
  errorClassName: string,

  validationErrorClassName: string,
  inputClassName: string,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string,
  label: oneOfType([string, node]),

  // Generated by final-form's Field component
  input: object.isRequired,
  meta: object.isRequired,
  passwordCheckRefValues: arrayOf(string.isRequired).isRequired,
  customErrorText: string,
  pwdStrgnthCheckReq: bool.isRequired,
};

const FieldPasswordComponent = injectIntl(FieldPasswordMainComponent);

const FieldPassword = props => {
  const [showPassword, setShowPassword] = useState(false);
  const { refValue, ...rest } = props;
  const inputProps = {
    ...rest,
    showPassword,
    setShowPassword,
  };
  const keyMaybe = !!refValue && { key: refValue };

  return (
    <Field component={FieldPasswordComponent} {...inputProps} {...keyMaybe} refValue={refValue} />
  );
};

export default FieldPassword;
